  <template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left> 球员数据 </template>
    <template v-slot:nav_right>
      <template v-if="isShowForCoach || isShowForExpert">
        <span class="nav-right-btn" @click="addPlayerScout">添加优秀苗子信息 / 球员评价</span>
      </template>
      <template v-if="isShowForSysOradmin">
        <span
          class="nav-right-btn"
          @click="openRecordDialog"
          v-if="isShowfocushistory"
          >球员关注记录</span
        >
        <span
          v-if="player.focus !== 1"
          class="nav-right-btn"
          @click="focusAction(true)"
          >关注此球员</span
        >
        <span v-else class="nav-right-btn" @click="focusAction(false)"
          >取消关注此球员</span
        >
      </template>
    </template>
    <div v-show="!loading" class="scroll_wrap">
      <vue-scroll>
        <div class="info_item" style="margin-bottom: 10px">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="" />
            基本信息
          </div>
          <div class="base_info">
            <div class="info">
              <div class="col">
                <span>身份证号：{{ user.idNumber }}</span>
                <span v-if="user.idNumber"
                  >年龄：{{ user.idNumber | getAgeFromIdNumberYear }}岁</span
                >
              </div>
              <div class="col">
                <span>性别：{{ user.gender || "--" }}</span>
                <span>生日：{{ user.idNumber | filterIdNumber }}</span>
              </div>
              <div class="col">
                <span>上海足协注册编号：{{ player.playerCode || "--" }}</span>
              </div>
              <!-- <div class="col">
                <span>管理单位：{{player.organShortName || '--'}}</span>
                <span>单位：{{player.youthShortName || '--' }}</span>
              </div>
              <div class="col" style="align-items: center">
                <template v-if="positions.length > 1">
                  <div style="width: 50%;">
                    <span v-for="(item,index) in positions"
                      :key="index">
                    场上位置{{index+1}}：{{item}}
                </span>
                  </div>
                </template>
                <template v-else>
                  <div style="width: 50%;"><span>场上位置：{{positions[0] || '--'}}</span></div>
                </template>
                <div style="width: 50%;">
                  <span >球衣号：{{player.playerNumber || '--'}}</span>
                </div>
              </div> -->
            </div>
            <div class="playerImg">
              <div class="focus-tips" v-if="player.focus === 1">
                <div class="tips-content">特别关注</div>
              </div>
              <img
                :src="user.headImgUrl ? user.headImgUrl : person"
                alt=""
                @error="user.headImgUrl = person"
              />
              <p>{{ user.idName }}</p>
            </div>
          </div>
        </div>
        <!--<div style="margin-left: 10px">-->
        <!--<a href="javascript:void(0);"  style="color: #4cd964">更多（连接中国足协信息化平台）</a>-->
        <!--</div>-->
        <div class="info_item">
          <div class="info_title between">
            <div class="flex_box">
              <img src="@/assets/images/common/player_squad.png" alt="" />
              所属球队
            </div>
            <!-- <div v-if="userRole !== 'player'" class="yioks_btn" @click="adjust = true">球队管理</div> -->
          </div>
          <div v-show="squadList.length > 0" class="score_wrap">
            <div
              v-for="(item, index) in squadList"
              :key="index"
              class="score_item"
              @click="goSquad(item)"
            >
              <div class="header">{{ item.shortName }}</div>
              <div class="content">
                <img
                  :src="item.banner"
                  alt=""
                  @error="item.banner = squadImg"
                />
                <div class="score_info">
                  <p>
                    <span
                      >单位：{{
                        `${item.organShortName} - ${item.youthShortName}`
                      }}</span
                    >
                  </p>
                  <p>
                    <span>主教练: {{ item.chiefCoachName }}</span>
                    <span>教练团队: {{ item.coachTeamNum }}人 </span>
                  </p>
                  <p>
                    <span>球员数量: {{ item.playerTeamNum }}人</span
                    ><span>球衣号：{{ item.playerNumber || "--" }}</span>
                  </p>
                  <p>
                    <span>场上位置：{{ item.position }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <yioks-empty v-if="squadList.length === 0" :h="'150px'"></yioks-empty>
        </div>
        <div class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex">
              <img
                src="@/assets/images/common/group_member.png"
                style="width: 0.25rem; height: 0.2rem"
                alt=""
              />
              运动能力测试
            </div>
            <div v-if="playerInfo.templateTitle">
              <p style="cursor: pointer" class="yioks_btn" @click="moreData">
                更多
              </p>
            </div>
          </div>
          <div v-if="showPlayerData" class="test-wrap">
            <div class="row over-hidden">
              <!-- <div class="label" style="border-bottom:1px solid #FFF">基础数据</div> -->
              <div
                class="col"
                style="border-bottom: 1px solid #fff; position: relative"
              >
                <div
                  class="col-tips"
                  v-if="playerInfo.official === 1"
                  style="background-color: #eb2c2c"
                >
                  <span>官方测试</span>
                </div>
                <div class="col-tips" v-else style="border: 1px solid">
                  <span>自行测试</span>
                </div>

                <div class="flex">
                  <span>测试时间：{{ playerInfo.testTime | time() }}</span>
                </div>
                <div class="flex">
                  <span>测试批次：{{ playerInfo.templateTitle }}</span>
                </div>
                <div class="flex">
                  <span>测试联系人：{{ playerInfo.linkMen }}</span>
                  <span
                    >测试联系人手机号：{{
                      playerInfo.linkMenPhone || "--"
                    }}</span
                  >
                </div>
                <div class="flex">
                  <span
                    >单位：{{
                      (playerInfo.organShortName || "--") +
                      " " +
                      (playerInfo.youthShortName || "--")
                    }}</span
                  >
                  <span
                    >测试海拔 ：{{
                      playerInfo.testRegion | testRegionFilter
                    }}</span
                  >
                </div>
                <div class="flex">
                  <span>测试地点 ：{{ playerInfo.testAddress || "--" }}</span>
                  <!--                  <span style="display: flex;padding-left:10px">-->
                  <!--                    <span v-if="playerInfo.bodyResult" style="padding-left:0">排名 ：{{playerInfo.bodyResult.ranking || '&#45;&#45;'}}</span>-->
                  <!--                    <span v-if="playerInfo.bodyResult" style="padding-left:0">总分 ：{{playerInfo.bodyResult.score || '&#45;&#45;'}}</span>-->
                  <!--                  </span>-->
                </div>
              </div>
            </div>
            <div class="row">
              <!-- <div class="label">测试数据</div> -->
              <div class="col">
                <div class="box-wrap">
                  <div
                    v-for="(item, index) in playerBody"
                    :key="index"
                    class="box"
                  >
                    <p class="indicatorName" v-if="item.score">
                      {{ item.indicatorName }}&nbsp;/&nbsp;得分
                    </p>
                    <p class="indicatorName" v-else>{{ item.indicatorName }}</p>
                    <p class="content">
                      {{ item.testResult || "--" }} &nbsp;
                      <span v-if="item.score">/&nbsp;{{ item.score }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <yioks-empty v-else h="150px"></yioks-empty>
        </div>
        <div class="info_item">
          <div class="info_title">
            <img src="@/assets/images/common/report_logo.png" alt="" />
            训练 / 比赛时长统计
<!--            训练时长统计-->
          </div>
          <div class="trainTime">
            <p class="col" style="border-right: 0px solid #fff;">
              训练总时长：{{ parseInt(player.trainingTime / 60) }} 小时
              {{ parseInt(player.trainingTime % 60) }} 分钟
            </p>
            <p class="col">
              比赛总时长：{{ parseInt(player.matchTime / 60) }} 小时
              {{ parseInt(player.matchTime % 60) }} 分钟
            </p>
          </div>
        </div>
        <!-- 球探报告 -->
        <div class="info_item">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="" />
            优秀苗子信息
          </div>
          <template  v-if="scoutPlayerDataVos && scoutPlayerDataVos.length">
            <div class="table" >
              <div class="row">
                <div class="th work">所属单位</div>
                <div class="th">所属球队</div>
                <div class="th">评价时间</div>
                <div class="th competition">比赛地点与场地</div>
                <div class="th">评价人</div>
                <div class="th">操作</div>
              </div>
              <div class="row" v-for="(item, index) in scoutPlayerDataVos" :key="index">
                <div class="td work">
                  <template v-if="item.organShortName || item.youthShortName">
                    <p>{{item.organShortName}}&nbsp;{{item.youthShortName}}</p>
                  </template>
                  <template v-else>
                    <p>--</p>
                  </template>
                </div>
                <div class="td">
                  <p>{{item.squadShortName || '--'}}</p>
                </div>
                <div class="td">
                  <p>{{item.scoutingTime | time(false)}}</p>
                </div>
                <div class="td competition">
                  <p>{{item.competition}}</p>
                </div>
                <div class="td">
                  <p class="" :class="userRole === 'system' || userRole === 'admin' ? 'suc link' : ''" @click="jumpToCoach(item)">{{item.scoutName}}</p>
                </div>
                <div class="td">
                  <el-button type="primary" size="small" @click="findScout(item)">查看</el-button>
                </div>
              </div>
            </div>
            <Pagination :total="total" :pageSize="pageSize" :page.sync="page" />
          </template>
          <template v-else>
            <yioks-empty h="150px"></yioks-empty>
            <div style="color:#4CD964;text-align:center;cursor:pointer" @click="addPlayerScout" v-if="isShowForCoach || isShowForExpert">添加优秀苗子信息 / 球员评价>></div>
          </template>

        </div>
        <!--训练详情-->
        <div v-if="trainingPlayerVos.length > 0" class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/report_logo.png" alt="" />
              <p>训练详情</p>
            </div>
            <div>
              <p style="cursor: pointer" class="yioks_btn" @click="DataPlan">
                全部
              </p>
            </div>
          </div>
          <div class="trainPlan">
            <div
              v-for="(item, index) in trainingPlayerVos"
              :key="index"
              class="planDetail"
            >
              <div class="row rowLine">
                训练单位：{{ item.organShortName }} {{ item.youthShortName }}
              </div>
              <div class="row">
                <div class="col">开始时间：{{ item.trainingTime | time }}</div>
                <div class="col">训练主题：{{ item.trainingName }}</div>
              </div>
              <div class="row">
                <div class="col">位置：{{ item.position || "--" }}</div>
                <div class="col">主教练：{{ item.chiefCoachName || "--" }}</div>
              </div>
              <div class="row">
                <div class="col">
                  训练时长：{{
                    parseInt(
                      (item.trainingTotalTime * item.attendance) / 100 / 60
                    )
                  }}
                  小时
                  {{
                    parseInt(
                      ((item.trainingTotalTime * item.attendance) / 100) % 60
                    )
                  }}分钟
                </div>
                <div class="col">
                  <span> 训练量： {{ item.trainingAmount || "--" }} </span>
                  <span style="margin-left: 40px">
                    训练强度：{{ item.trainingIntensity || "--" }}
                  </span>
                </div>
              </div>
              <div class="row rowLine">
                训练计划总体描述：<span v-html="item.overallEvalComment"></span>
              </div>
              <div class="row rowLine">
                球员总体评价：{{ item.generalEvalComments || "--" }}
              </div>
              <div class="row rowLine">
                技术评价： {{ item.technicalScore || "--" }}
              </div>
              <div class="row rowLine">
                战术评价： {{ item.tacticalScore || "--" }}
              </div>
              <div class="row rowLine">
                体能评价： {{ item.physicalScore || "--" }}
              </div>
              <div class="row rowLine">
                心智评价： {{ item.psychologicalScore || "--" }}
              </div>
              <div class="row rowLine">
                社交评价： {{ item.overallScore || "--" }}
              </div>
              <div class="row rowLine">
                建议：{{ item.learningObjectives || "--" }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/report_logo.png" alt="" />
              <p>训练详情</p>
            </div>
          </div>
          <yioks-empty :h="'150px'"></yioks-empty>
        </div>

        <!--新的比赛详情-->
        <div v-if="matchMatchReportPlayerVos.length > 0" class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/report_logo.png" alt="" />
              <p>比赛报告详情</p>
            </div>
            <div>
              <p style="cursor: pointer" class="yioks_btn" @click="moreMatchReport">
                全部
              </p>
            </div>
          </div>
          <div class="trainPlan">
            <div
                v-for="(item, index) in matchMatchReportPlayerVos"
                :key="index"
                class="planDetail"
            >
              <div class="row">
                <div class="col">比赛名称：{{ item.matchName || "--" }}（{{ item.matchType }}）</div>
                <div class="col">比赛结果：{{ item.matchResult }}（{{item.totalGoalScore}}：{{item.totalGoalConceded}}）</div>
              </div>
              <div class="row">
                <div class="col">开始时间：{{ item.matchTime | time }}</div>
                <div class="col">比赛时长：{{parseInt(item.matchTotalTime / 60)}} 小时 {{item.matchTotalTime % 60}} 分钟</div>
              </div>
              <div class="row">
                <div class="col">比赛对手：{{ item.vs || "--" }}</div>
                <div class="col">主要阵型：{{ item.teamFormation || "--" }}</div>
              </div>
              <div class="row">
                <div class="col">比赛地点：{{ item.matchPlace || "--" }}</div>
                <div class="col">比赛天气：{{ item.weather || "--" }}</div>
              </div>
              <div class="row">
                <div class="col">
                  上场是时间：{{parseInt(item.attendanceTime / 60)}} 小时 {{item.attendanceTime % 60}} 分钟
                </div>
                <div class="col">
                  <span> 进球数： {{ item.goalScore }} </span>
                  <span style="margin-left: 40px">
                    助攻数：{{ item.goalAssisted }}
                  </span>
                </div>
              </div>
              <div class="row rowLine">
                比赛总结：<span v-html="item.matchSummary"></span>
              </div>
              <div class="row rowLine">
                球员总体评价：{{ item.generalEvalComments || "--" }}
              </div>
              <div class="row rowLine">
                技术评价： {{ item.technicalScore || "--" }}
              </div>
              <div class="row rowLine">
                战术评价： {{ item.tacticalScore || "--" }}
              </div>
              <div class="row rowLine">
                体能评价： {{ item.physicalScore || "--" }}
              </div>
              <div class="row rowLine">
                心智评价： {{ item.psychologicalScore || "--" }}
              </div>
              <div class="row rowLine">
                社交评价： {{ item.overallScore || "--" }}
              </div>
              <div class="row rowLine">
                建议：{{ item.learningObjectives || "--" }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/report_logo.png" alt="" />
              <p>比赛报告详情</p>
            </div>
          </div>
          <yioks-empty :h="'150px'"></yioks-empty>
        </div>

<!--        原先的比赛详情-->
<!--        <div v-if="matchTrainingPlayerVos.length > 0" class="info_item">-->
<!--          <div class="info_title" style="justify-content: space-between">-->
<!--            <div style="display: flex; align-items: center">-->
<!--              <img src="@/assets/images/common/report_logo.png" alt="" />-->
<!--              <p>比赛详情</p>-->
<!--            </div>-->
<!--            <div>-->
<!--              <p style="cursor: pointer" class="yioks_btn" @click="moreMatch">-->
<!--                全部-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="trainPlan">-->
<!--            <div-->
<!--              v-for="(item, index) in matchTrainingPlayerVos"-->
<!--              :key="index"-->
<!--              class="planDetail"-->
<!--            >-->
<!--              <div class="row">-->
<!--                <div class="col">开始时间：{{ item.trainingTime | time }}</div>-->
<!--                <div class="col">比赛主题：{{ item.trainingName }}</div>-->
<!--              </div>-->
<!--              <div class="row">-->
<!--                <div class="col">-->
<!--                  位置：{{ item.positionId | positionStatus }}-->
<!--                </div>-->
<!--                <div class="col">主教练：{{ item.chiefCoachName }}</div>-->
<!--              </div>-->
<!--              <div class="row">-->
<!--                <div class="col">技术： {{ item.technicalScore }}分</div>-->
<!--                <div class="col">战术： {{ item.tacticalScore }}分</div>-->
<!--              </div>-->
<!--              <div class="row">-->
<!--                <div class="col">体能： {{ item.physicalScore }}分</div>-->
<!--                <div class="col">心理： {{ item.psychologicalScore }}分</div>-->
<!--              </div>-->
<!--              <div class="row rowLine">-->
<!--                比赛时长：{{-->
<!--                  parseInt(-->
<!--                    (item.trainingTotalTime * item.attendance) / 100 / 60-->
<!--                  )-->
<!--                }}-->
<!--                小时-->
<!--                {{-->
<!--                  parseInt(-->
<!--                    ((item.trainingTotalTime * item.attendance) / 100) % 60-->
<!--                  )-->
<!--                }}-->
<!--                分钟-->
<!--              </div>-->
<!--              <div class="row rowLine">-->
<!--                比赛目标：{{ item.learningObjectives || "&#45;&#45;" }}-->
<!--              </div>-->
<!--              <div class="row rowLine">-->
<!--                总体评价：{{ item.generalEvalComments || "&#45;&#45;" }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div v-else class="info_item">-->
<!--          <div class="info_title" style="justify-content: space-between">-->
<!--            <div style="display: flex; align-items: center">-->
<!--              <img src="@/assets/images/common/report_logo.png" alt="" />-->
<!--              <p>比赛详情</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <yioks-empty :h="'150px'"></yioks-empty>-->
<!--        </div>-->



        <div v-if="videoToPlayerVos.length > 0" class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/report_logo.png" alt="" />
              <p>个人视频库</p>
            </div>
            <div style="display: flex">
              <p style="margin-right: 10px; display: flex" v-if="isCanEditData">
                <span
                  style="cursor: pointer"
                  class="yioks_btn"
                  @click="addMedia"
                  >本地上传视频</span
                >
                <span
                  style="cursor: pointer"
                  class="yioks_btn"
                  @click="associateMore"
                  >从视频库中选择</span
                >
              </p>
              <!--              <p  @click="associateMore">继续关联</p>-->
              <p style="cursor: pointer" class="yioks_btn" @click="mediaMore">
                全部
              </p>
            </div>
          </div>
          <div class="trainPlan">
            <div
              v-for="(item, index) in videoToPlayerVos"
              :key="index"
              class="mediaDetail"
              @click.stop="goDetail(item.videoUuid)"
            >
              <div class="img">
                <img
                  class="playImg"
                  :src="playImg"
                  style="position: absolute; top: 30px; left: 65px"
                  @click.stop="
                    openVideoDialog(item.videoAddress, item.videoCoverAddress)
                  "
                />
                <img
                  class="coverImg"
                  :src="item.videoCoverAddress || planImg"
                  alt=""
                  style="width: 170px; height: 100px"
                  @error="item.videoCoverAddress === planImg"
                />
              </div>
              <div class="intro">
                <p class="p_item">标题：{{ item.videoTitle || "--" }}</p>
                <p class="p_item">上传人：{{ item.authorName }}</p>
                <p>
                  时长： {{ filterTime(parseInt(item.videoDuration / 60)) }}:{{
                    filterTime(item.videoDuration % 60)
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/videoIcon.png" alt="" />
              <p>个人视频库</p>
            </div>
            <div style="display: flex" v-if="isCanEditData">
              <p style="display: flex">
                <span
                  style="cursor: pointer"
                  class="yioks_btn"
                  @click="addMedia"
                  >本地上传视频</span
                >
                <span
                  style="cursor: pointer"
                  class="yioks_btn"
                  @click="associateMore"
                  >从视频库中选择</span
                >
              </p>
            </div>
          </div>
          <yioks-empty :h="'150px'"></yioks-empty>
        </div>
        <!--人才输送-->
        <div v-if="recordPlayerToYouthToSquadListVos.length > 0" class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/report_logo.png" alt="" />
              <p>培养成效</p>
            </div>
          </div>
          <div class="trainPlan">
            <div
              v-for="(item, index) in recordPlayerToYouthToSquadListVos"
              :key="index"
              class="planDetail"
              style="margin-bottom:10px"
            >
              <div class="row rowLine">
                高水平赛事 {{index+1}} ：{{ item.recordName }}
              </div>
              <div class="row">
                <div class="col">赛事类型：{{ item.squadSex === "male" ? "男足" : item.squadSex === "mixed" ? "与其他单位球员联合组队" : "女足"}}</div>
                <div class="col">赛事分组：{{item.squadLevel}}</div>
              </div>
              <div class="row">
                <div class="col">机构参赛球队名称：{{ item.squadName }}</div>
                <div class="col">取得成绩：第{{ item.squadRanking}}名</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="info_item">
          <div class="info_title" style="justify-content: space-between">
            <div style="display: flex; align-items: center">
              <img src="@/assets/images/common/report_logo.png" alt="" />
              <p>培养成效</p>
            </div>
          </div>
          <yioks-empty :h="'150px'"></yioks-empty>
        </div>

      </vue-scroll>
    </div>
    <el-dialog
      :visible.sync="adjust"
      width="500px"
      title="球队管理"
      :close-on-click-modal="false"
      custom-class="yioks_alert"
    >
      <div style="display: flex; align-items: center">
        <p style="height: 40px; line-height: 40px">球队选择：</p>
        <el-select
          v-model="squadUuid"
          filterable
          placeholder="请选择"
          style="margin-left: 20px; width: 300px"
        >
          <el-option
            v-for="item in allSquadList"
            :key="item.uuid"
            :label="item.shortName"
            :value="item.uuid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="radio_btn">
        <el-button
          type="primary"
          style="margin-right: 20px"
          @click="adjustSquad"
          >确定</el-button
        >
        <el-button type="danger" @click="adjust = false">取消</el-button>
      </div>
    </el-dialog>
    <yioks-loading v-if="loading"></yioks-loading>
    <template v-if="showVideo">
      <el-dialog
        :visible.sync="showVideo"
        width="800px"
        class="linkAllDialog"
        :close-on-click-modal="false"
        top="12vh"
      >
        <div style="text-align: center; background-color: black; width: 760px">
          <video
            ref="video"
            controls
            width="760"
            autoplay
            disablePictureInPicture
            :poster="poster"
            controlsList="nodownload noremoteplayback"
            height="400"
          >
            <source :src="videoSrc" type="video/mp4" />
          </video>
        </div>
      </el-dialog>
    </template>
    <template v-if="showDialog">
      <associateMore
        :objectUuid="playerUuid"
        :type="link.type"
        :obj="propObj"
        :title="link.title"
        :organUuid="player.organUuid"
        :youthUuid="player.youthUuid"
        :showDialog.sync="showDialog"
        @hideDialog="hideDialog"
      ></associateMore>
    </template>
    <template v-if="showMediaUpload">
      <!-- 系统管理员上传球员视频 -->
      <uploadMedia
        :showTip.sync="showMediaUpload"
        :orgInfo="orgInfo"
        :uuid="propUuid"
        :isSquadShow="true"
        :videoType="'player'"
        :sequadSelectList="sequadSelectList"
        @hideUploadDialog="hideUploadDialog"
      ></uploadMedia>
    </template>
    <template v-if="isShowRecordDialog">
      <el-dialog
        :visible.sync="isShowRecordDialog"
        width="800px"
        custom-class="record-dialog"
        :close-on-click-modal="false"
        top="12vh"
      >
        <div class="title" slot="title">
          <div class="title-text">关注记录</div>
        </div>

        <div class="dialog-content">
          <div class="time-line-wrapper scroll-wrapper" v-if="auditList.length">
            <vue-scroll>
              <div
                class="time-item"
                v-for="(item, index) in auditList"
                :key="index"
              >
                <div class="line"></div>
                <div class="item-left">
                  {{ item.whatAction | focusFormater }}
                </div>
                <div class="item-right">
                  <div
                    class="time-content"
                    style="display: flex; justify-content: space-between"
                  >
                    <span>{{ item.updatedAt | time(true) }}</span>
                    <span style="margin-right: 10px"
                      >操作人：{{ item.idName || "--" }}</span
                    >
                  </div>
                  <div class="item-info">
                    <div class="info-text">
                      状态：
                      <span>
                        {{ item.whatAction | focusFormaterContent }}
                      </span>
                    </div>
                    <div class="info-text">
                      理由： <span> {{ item.remark || "--" }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
          <div class="time-line-wrapper" style="line-height: 20px" v-else>
            <p>暂无数据</p>
          </div>
        </div>
      </el-dialog>
    </template>
    <!--    <yioks-tip-->
    <!--      :showTip="isShowTips"-->
    <!--      :tipMsg="tipsMsg"-->
    <!--      @callback="tipsCallBack"-->
    <!--    />-->
    <el-dialog
      :visible.sync="isShowTips"
      width="400px"
      :close-on-click-modal="false"
      custom-class="focus-action-tips"
    >
      <div class="tips-title-wrapper" slot="title">
        {{ focusActionTitle }}
      </div>
      <div class="focus-action-content">
        <div class="tips-text">
          <div style="width: 110px">快捷短语：</div>
          <el-select
            v-model="tipsSelect"
            style="width: 100%"
            class="yioks-outline"
            placeholer="可选择快捷短语"
            @change="tipsSelectChange"
          >
            <el-option
              v-for="(item, index) in tipsList"
              :key="index"
              class="yioks-outline"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="tips-info">
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            class="yioks-outline"
            :rows="3"
            v-model="tipsInfo"
            :placeholder="tipsPlaceholer"
          ></el-input>
        </div>
      </div>

      <template slot="footer">
        <div class="footer-btns-wrapper">
          <!--          <el-popover-->
          <!--            v-model="isShowPoper"-->
          <!--            placement="top">-->
          <!--            <p v-if="isFocus">确认关注该球员吗?</p>-->
          <!--            <p v-else>确认取消关注该球员吗?</p>-->
          <!--            <div style="text-align: right; margin: 0">-->
          <!--              <el-button size="mini" type="text" @click="isShowPoper = false">取消</el-button>-->
          <!--              <el-button type="primary" size="mini" @click="confirmFocus">确定</el-button>-->
          <!--            </div>-->
          <!--            <el-button slot="reference" type="primary" size="normal">确认</el-button>-->
          <!--          </el-popover>-->
          <el-button
            slot="reference"
            type="primary"
            size="normal"
            @click="confirmFocus"
            >确认</el-button
          >
          <el-button type="danger" size="normal" @click="oncancel"
            >取消</el-button
          >
        </div>
      </template>
    </el-dialog>
    <el-dialog
      :visible.sync="batchAdd"
      width="500px"
      title="选择球员"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="yioks_alert2"
    >
      <el-form ref="batchInfo" :model="batchInfo" label-width="120px">
        <vue-scroll ref="scroll" :ops="ops">
          <div style="margin-right: 30px">
            <template v-if="isStuExit">
              <el-form-item
                label="选择球队"
                prop="unitId"
                :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]"
              >
                <el-select
                  v-model.trim="batchInfo.unitId"
                  style="width: 100%"
                  no-data-text="暂时没有球队，请前往球队管理添加球队"
                  :placeholder="$t('teamPlaceholder')"
                  @change="changeUnitUUid"
                >
                  <el-option
                    v-for="(item, index) in selectsquadList"
                    :key="index"
                    :label="item.label"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="选择球员"
                required
                prop="playerUuid"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-select
                  v-model.trim="batchInfo.playerUuid"
                  style="width: 100%"
                  placeholder="请选择球员"
                  no-data-text="暂时没有球员，请前往球员管理添加球员"
                  filterable
                  @change="playerChange"
                >
                  <el-option
                    v-for="(item, index) in playerList"
                    :key="index"
                    :value="item.uuid"
                    :label="item.uname"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="场上主要位置" prop="position"
                :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]">
                <el-select v-model="batchInfo.position" class="w_100" placeholder="请选择场上主要位置">
                  <el-option v-for="item in positionList" :key="item.uuid" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="球员姓名" prop="player_name"
                :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-input v-model="batchInfo.player_name" placeholder="请输入球员姓名"></el-input>
              </el-form-item>
              <el-form-item label="证件号" prop="player_id_number"
                :rules="[{ required: true, message: '必填项', trigger: 'blur' }, {
                    required: true, validator: checkIdnumber, trigger: ['blur', 'change']
                  }]">
                <el-input v-model="batchInfo.player_id_number" placeholder="请输入证件号"></el-input>
              </el-form-item>
              <el-form-item label="场上主要位置" prop="position"
                :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]">
                <el-select v-model="batchInfo.position" class="w_100" placeholder="请选择场上主要位置">
                  <el-option v-for="item in positionList" :key="item.uuid" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </div>
        </vue-scroll>
      </el-form>
      <div class="btn-wrapper">
        <el-button type="primary" @click="toAddScout">添加优秀苗子信息 / 球员评价</el-button>
      </div>
    </el-dialog>
  </SubContent>
</template>

<script>
import player from "@/api/player";
import scout from "@/api/scout";
import common from "@/api/common";
import squad from "@/api/squad";
import person from "@/assets/images/common/person.jpg";
import playImg from "@/assets/images/common/playImg.png";
import squadImg from "@/assets/images/common/squad.png";
import planImg from "@/assets/images/common/plan_default.png";
import formRules from '@/utils/formRules/rules';
import {
  filterIdNumber,
  positionStatus,
  testRegionFilter,
  getAgeFromIdNumberYear,
} from "@/utils/yioks_filter";
import body from "@/api/body";
import storage from "@/utils/storage";
import mixinAppConfig from "@/mixin/mixinAppConfig";
import {ops} from "@/utils/scrollIndialog";
export default {
  components: {
    SubContent: () => import("@/components/layout/newSubContent"),
    associateMore: () => import("@/components/associatedDialog/associatedMore"),
    uploadMedia: () => import("@/views/media/uploadMedia"),
    Pagination: () => import("@/components/Pagination"),
  },
  filters: {
    filterIdNumber,
    getAgeFromIdNumberYear,
    positionStatus,
    testRegionFilter,
    filterTime(val) {
      return `${parseInt(val / 60)} 小时 ${val % 60} 分`;
    },
    focusFormater(val) {
      let tips = "--";
      switch (val) {
        case "focus":
          tips = "关注";
          break;
        case "unfocus":
          tips = "取消";
          break;
        default:
          break;
      }
      return tips;
    },
    focusFormaterContent(val) {
      let tips = "--";
      switch (val) {
        case "focus":
          tips = "关注";
          break;
        case "unfocus":
          tips = "取消关注";
          break;
        default:
          break;
      }
      return tips;
    },
  },
  mixins: [mixinAppConfig],
  data() {
    return {
      ops,
      planImg,
      squadImg,
      userRole: storage.get("userInfo").userRole,
      showMediaUpload: false,
      orgInfo: {},
      showDialog: false,
      link: {
        title: "",
        type: "",
      },
      propObj: {},
      person,
      playImg,
      videoSrc: "",
      poster: "",
      showVideo: false,
      playerUuid: this.$route.query.uuid,
      player: "",
      squad: [],
      loading: true,
      trainingTime: 0,
      adjust: false,
      squadUuid: "",
      user: {},
      squadList: [],
      sequadSelectList: [], // 添加视频弹窗用数据
      allSquadList: [],
      trainingPlayerVos: [],
      videoToPlayerVos: [],
      matchTrainingPlayerVos: [], //老比赛
      matchMatchReportPlayerVos: [],//新比赛
      recordPlayerToYouthToSquadListVos: [],//人才输送
      propUuid: "",
      playerBody: [],
      playerInfo: {},
      positions: [],
      showPlayerData: false,
      isShowRecordDialog: false, // 关注记录弹窗
      auditList: [], // 测试用时间记录
      isShowTips: false, // 关注/取消关注提示
      tipsMsg: "",
      tipsInfo: "", // 提示备注信息
      isFocus: true, // 提示状态，true/false 关注/取消关注
      focusActionTitle: "关注提示",
      tipsPlaceholer: "", // 占位提示
      tipsSelect: null, // 快捷提示语
      isShowPoper: false,
      tipsList: [
        {
          label: "无",
          value: 1,
        },
        {
          label: "2021年第一期05、06年龄段精英训练营",
          value: 2,
        },
        {
          label: "2021年第二期07、08年龄段精英训练营",
          value: 3,
        },
      ], // 快捷提示语列表
      isShowfocushistory: false,
      scoutPlayerDataVos: [],
      total: 0,
      page: 0,
      pageSize: 5,
      whiteUuidList: [],
      batchAdd: false, // 弹窗
      batchInfo: {
        organUuid: "", // 协会
        organShortName: "",
        youthUuid: "", // 机构
        youthShortName: "",
        squadUuid: "", // 球队
        playerUuid: "", // 球员
        unitId: "", // 联合信息
        player_name: "",
        player_id_number: "",
        position: "",
      }, // 弹窗表单
      isStuExit: false,
      batchOrganList: [], // 管理协会列表
      batchCenterList: [], // 单位列表
      batchSquadList: [], //  球队列表
      playerList: [], //球员列表
      selectsquadList: [],
      positionList: [],
    };
  },
  watch: {
    adjust(val) {
      if (!val) this.squadUuid = this.player.squadUuid;
    },
  },
  computed: {
    isShowForSysOradmin() {
      return this.userRole === "system" || this.userRole === "admin" || this.userRole === "youth" || this.userRole == "club" || this.userRole == 'coach';
    },
    isShowForCoach() {
      return this.userRole === 'coach';
    },
    isShowForExpert() {
      return this.userRole === 'expert';
    },
  },
  created() {
    this.getInfo();
    this.getPlayerBody();
    // this.getCommonData()
    this.loadFocusHistory();
    this.getWhiteUuidList();
    if(this.isShowForCoach){
      this.getSquadList();
    }
    this.loadPositionInfo();

  },
  methods: {
    filterTime(val) {
      if (val === 0) {
        return "00";
      }
      if (String(val).length < 2) {
        return "0" + String(val);
      } else {
        return val;
      }
    },
    getPlayerBody() {
      body
        .getPlayerBodyData(this.playerUuid, { page: 0, size: 1 })
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            // this.$router.push('/')
          } else {
            const data = res.content[0] ? res.content[0] : {};
            this.showPlayerData = !!res.content.length;
            this.playerInfo = data;
            this.playerBody = data.infoVos || [];
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getFreeSquadList(youthUuid) {
      squad.getFreeSquadList(youthUuid).then((res) => {
        this.allSquadList = res;
      });
    },
    getCommonData() {
      common.getAllSquad().then((res) => {
        this.squadList = res;
      });
    },
    getInfo() {
      player
        .getPlayerInfo(this.playerUuid)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.loading = false;
            this.player = res.player;
            this.user = res.user;
            // this.squadUuid = res.player.squadUuid
            this.squadList = res.squadList;
            if(this.squadList.length>1){
              this.isStuExit = true;
            }
            this.batchInfo.player_id_number = this.user.idNumber;
            this.batchInfo.player_name = this.user.idName;
            this.sequadSelectList = res.squadList.map((item) => {
              const { organShortName, organUuid, youthShortName, youthUuid } =
                item;
              return {
                label: `${organShortName} ${youthShortName}`,
                value: JSON.stringify({
                  organShortName,
                  organUuid,
                  youthShortName,
                  youthUuid,
                }),
              };
            });
            this.trainingTime = res.trainingTime;
            let positionName = this.player.position;
            this.positions = positionName.split(",");
            this.trainingPlayerVos = res.trainingPlayerVos || [];
            this.recordPlayerToYouthToSquadListVos = res.recordPlayerToYouthToSquadListVos || [];
            if (res.trainingPlayerVos.length > 0) {
              this.trainingPlayerVos = [res.trainingPlayerVos[0]];
            }
            this.videoToPlayerVos = res.videoToPlayerVos || [];
            // // 老比赛
            // if (res.matchTrainingPlayerVos.length > 0) {
            //   this.matchTrainingPlayerVos = [res.matchTrainingPlayerVos[0]];
            // }
            // 新比赛
            if (res.matchMatchReportPlayerVos.length > 0) {
              this.matchMatchReportPlayerVos = [res.matchMatchReportPlayerVos[0]];
            }
            // this.getFreeSquadList(res.player.youthUuid)  // 暂时不请求
            this.getScoutListInfo();  // 获取球探报告
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    /* 球员变化 */
    playerChange(val) {
      //   console.log("球员", val);
    },
    /* 获取position定位 */
    loadPositionInfo() {
      const params = {};
      player
      .allPositionList(params)
      .then((res) => {
        this.positionList = res.map((item) => ({
          uuid: item.uuid,
          name: item.playerPositionName,
        }));
      })
      .catch((err) => {
        console.error(res);
      });
    },
    checkIdnumber: (rules, val, callback) => {
      console.log('formRules.idNumber(val)', formRules.idNumber(val))
      if(formRules.idNumber(val)) {
        callback()
      } else {
        callback('证件号错误')
      }
    },
    toAddScout() {
      let queryData = {};
      this.batchInfo.player_id_number = this.batchInfo.player_id_number.trim().toUpperCase();
      this.batchInfo.player_name = this.batchInfo.player_name.trim();
      if(this.isStuExit) {
        let { organShortName, youthShortName, playerUuid, unitId, position, ...rest } =
          this.batchInfo;
        queryData = {
          playerUuid,
          position: position,
          ...rest,
        };
        if (unitId) {
          const { organUuid, squadUuid, youthUuid } = JSON.parse(unitId);
          queryData = Object.assign({}, queryData, {
            organUuid,
            squadUuid,
            youthUuid,
          });
        }
      } else {
        let { player_name, player_id_number, position } = this.batchInfo;
        queryData = {
          player_name, player_id_number, position
        }
      }
      // console.log('queryData', queryData)
      // return
      this.$refs.batchInfo.validate((valid) => {
        if(valid) {
          if(this.isStuExit){
            this.$router.push({
              name: "ScoutAdd",
              query: queryData,
            });
          }else{
            scout
            .scoutPlayerDataVerify(this.batchInfo.player_id_number,this.batchInfo.player_name)
            .then((res) => {
              if (res.code) {
                this.$message.error(res.msg);
              } else {
                this.$router.push({
                  name: "ScoutAdd",
                  query: queryData,
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
          }
        } else {
          //          this.$message.warning("请先选择球员");
        }
      })

    },
    getSquadList() {
      const _ = require("lodash");
      squad
      .getSquadListCoachAll()
      .then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }
        const uni_selectYouthList = _.unionBy(res, "squadUuid");
        this.selectsquadList = uni_selectYouthList.map((item) => ({
          label: `${item.organShortName} - ${item.youthShortName} - ${item.shortName}`,
          value: item.squadUuid,
          key: JSON.stringify({
            squadUuid: item.squadUuid,
            youthUuid: item.youthUuid,
            organUuid: item.organUuid,
            organShortName: item.organShortName,
            youthShortName: item.youthShortName,
            shortName: item.shortName,
          }),
        }));
      })
      .catch((err) => {
        console.error("err", err);
      });
    },
    getScoutListInfo() {
      let requestName = "";
      if (this.userRole === "organ") {
        requestName = scout.getScoutListByOrg;
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        requestName = scout.getScoutListBySystem;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        requestName = scout.getScoutListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        requestName = scout.getScoutListByTeacher;
      }
      // user.idNumber
      const pageObj = {
        page: this.page,
        size: this.pageSize,
        playerIdNumber: this.user.idNumber
      };
      requestName(pageObj)
      .then(res => {
        const { content, totalElements } = res;
        this.total = totalElements;
        return content
      })
      .then(list => {
        this.scoutPlayerDataVos = list;
      })
      .catch(err => {
        console.error('err', err)
      })
    },
    findScout(row) {
      // scout/details?dataUuid=04928dca0e47485a8d975b2e1f673e89&playerUuid=f923fde3fda64bd3a7229113a859b8d9
      const { uuid, playerUuid } = row;
      this.$router.push({
        path: '/scout/details',
        query: {
          dataUuid: uuid,
          playerUuid,
        }
      })
    },
    changeUnitUUid(val) {
      if (val) {
        const {
          organShortName,
          organUuid,
          shortName,
          squadUuid,
          youthShortName,
          youthUuid,
        } = JSON.parse(val);
        if (!squadUuid) {
          throw new Error("squadUuid is error:", squadUuid);
          return;
        }
        player
        .getSquadPlayer(squadUuid)
        .then((res) => {
          this.playerList = res.map((item) => ({
            uuid: item.uuid,
            uname: item.idName,
          }));
        })
        .catch((err) => {
          console.error(err);
        });
      }
    },
    // 获取可查看所属球队名单
    getWhiteUuidList() {
      let request = null;
      const whiteUuidList = [];
      try {
        if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
          // request = squad.getOrgListBySystem;
          // 系统管理员不做处理
          return;
        } else if (this.userRole === "organ") {
          request = squad.getOrgListByOrgan;
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if (res.length === 1) {
              res.forEach((orgItem) => {
                whiteUuidList.push(orgItem.organUuid);
              });
              this.whiteUuidList = whiteUuidList;
            } else {
              console.error("error:当前登录协会存在多个协会数据");
              this.whiteUuidList = [];
            }
          });
        } else if (
          this.userRole === "youth" ||
          this.userRole === "trainCamp" ||
          this.userRole === "club"
        ) {
          request = squad.getOrgListByYouth;
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if (res.length === 1) {
              if (res[0].youthList.length === 1) {
                res[0].youthList.forEach((youthItem) => {
                  whiteUuidList.push(youthItem.uuid);
                });
                this.whiteUuidList = whiteUuidList;
              } else {
                console.error("error:当前登录青训中心存在多个青训中心角色数据");
                this.whiteUuidList = [];
              }
            } else {
              console.error("error:当前登录协会存在多个协会数据");
              this.whiteUuidList = [];
            }
          });
        } else if(this.userRole === 'coach') {
          request = squad.getSquadListCoachAll
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if(res.length) {
              res.forEach(squadItem => {
                whiteUuidList.push(squadItem.squadUuid)
              })
              this.whiteUuidList = whiteUuidList;
            } else{
              console.error("error:当前登录教练不存在球队信息");
            }
          });
        }
      } catch (err) {
        console.error("err", err);
      }
    },

    goSquad(row) {
      const { uuid } = row;
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        this.$router.push({
          path: "/squad/detail",
          query: {
            uuid,
          },
        });
      } else if (this.userRole === "organ") {
        const { organUuid } = row;
        if (this.whiteUuidList.includes(organUuid)) {
          this.$router.push({
            path: "/squad/detail",
            query: {
              uuid,
            },
          });
        } else {
          this.$message.error('很抱歉，您没有权限访问这个球队信息')
        }
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        const { youthUuid } = row;
        if (this.whiteUuidList.includes(youthUuid)) {
          this.$router.push({
            path: "/squad/detail",
            query: {
              uuid,
            },
          });
        } else {
          this.$message.error('很抱歉，您没有权限访问这个球队信息')
        }
      } else if(this.userRole) {
        if(this.whiteUuidList.includes(uuid)) {
          this.$router.push({
            path: "/squad/detail",
            query: {
              uuid,
            },
          });
        } else {
          this.$message.error('很抱歉，您没有权限访问这个球队信息')
        }
      } else {
        console.log('login user role has error !!!')
      }
    },

    adjustSquad() {
      if (this.squadUuid === this.player.squadUuid) {
        this.adjust = false;
      } else {
        let data = {
          playerUuid: this.playerUuid,
          squadUuid: this.squadUuid,
        };
        player.playerChangeSquad(data).then((res) => {
          this.$set(this.player, "squadUuid", this.squadUuid);
          this.getInfo();
          // this.$set(this.player, 'squadUuid',this.squadUuid)
          this.adjust = false;
          this.$message.success("修改成功");
        });
      }
    },
    openVideoDialog(src, poster) {
      this.videoSrc = src;
      this.poster = poster || "";
      this.showVideo = true;
    },
    goDetail(uuid) {
      this.$router.push({
        path: "/media/detail",
        query: {
          uuid,
        },
      });
    },
    mediaMore() {
      this.$router.push({
        path: "moreMedia",
        query: {
          uuid: this.playerUuid,
        },
      });
    },
    addMedia() {
      this.propUuid = this.player.uuid;
      this.orgInfo = {
        organUuid: this.player.organUuid,
        organShortName: this.player.organShortName,
        youthUuid: this.player.youthUuid,
        youthShortName: this.player.youthShortName,
      };
      this.showMediaUpload = true;
    },
    associateMore() {
      this.$set(this.link, "type", "media");
      this.$set(this.link, "title", "从视频库中选择");
      this.showDialog = true;
    },
    hideDialog(val) {
      this.showDialog = val;
      this.getInfo();
    },
    hideUploadDialog(val) {
      this.showMediaUpload = val;
      this.getInfo();
    },
    DataPlan() {
      this.$router.push({
        path: "moreTraining",
        query: {
          uuid: this.playerUuid,
        },
      });
    },
    // 老比赛
    moreMatch() {
      this.$router.push({
        path: "moreMatchTraining",
        query: {
          uuid: this.playerUuid,
        },
      });
    },
    // 新比赛
    moreMatchReport() {
      this.$router.push({
        path: "moreMatchReport",
        query: {
          uuid: this.playerUuid,
        },
      });
    },
    moreData() {
      this.$router.push({
        path: "testData",
        query: {
          uuid: this.playerUuid,
        },
      });
    },
    /* 获取记录信息 */
    loadFocusHistory() {
      player
        .findPlayerFocusRecord(this.playerUuid)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.code);
            return;
          }
          this.auditList = res;
          if (res.length) {
            this.isShowfocushistory = true;
          } else {
            this.isShowfocushistory = false;
          }
          // this.isShowRecordDialog = true
        })
        .catch((err) => {
          console.error(err);
        });
    },
    /* 打开记录弹窗 */
    openRecordDialog() {
      this.isShowRecordDialog = true;
      // player.findPlayerFocusRecord(this.playerUuid)
      //   .then(res => {
      //     if(res.code) {
      //       this.$message.error(res.code)
      //       return
      //     }
      //     this.auditList = res;
      //     this.isShowRecordDialog = true
      //   })
      //   .catch(err => {
      //     console.error(err)
      //   })
    },
    addPlayerScout() {
      this.batchAdd = true;
    },
    /* 关注/取消关注球员 */
    focusAction(status) {
      if (status) {
        this.tipsMsg = "确认关注该球员？";
        this.focusActionTitle = "关注原因";
        this.tipsPlaceholer = "添加关注原因";
      } else {
        this.tipsMsg = "确认取消关注该球员？";
        this.focusActionTitle = "取消关注原因";
        this.tipsPlaceholer = "添加取消关注原因";
      }
      this.isFocus = status;
      this.isShowTips = true;
    },

    /* 提示回掉 */
    tipsCallBack(ok) {
      if (ok) {
        let submitData = {
          playerUuid: this.playerUuid,
          whatAction: "",
        };
        if (this.isFocus) {
          this.$set(submitData, "whatAction", "focus");
        } else {
          this.$set(submitData, "whatAction", "unfocus");
        }
        player
          .toChangePlayerFocusAction(submitData)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.getInfo();
            this.isShowTips = false;
          })
          .catch((err) => {
            console.error("err", err);
            this.isShowTips = false;
          });
      } else {
        this.isShowTips = false;
      }
    },

    /* 快捷提示语提示 */
    tipsSelectChange(val) {
      if (this.tipsSelect) {
        switch (val) {
          case 1:
            this.tipsInfo = "";
            break;
          case 2:
            this.tipsInfo = "2021年第一期05、06年龄段精英训练营";
            break;
          case 3:
            this.tipsInfo = "2021年第二期07、08年龄段精英训练营";
            break;
          default:
            this.tipsInfo = "";
            break;
        }
      }
    },

    /* 确认操作 */
    confirmFocus() {
      let submitData = {
        playerUuid: this.playerUuid,
        remark: this.tipsInfo,
        whatAction: "",
      };
      if (this.isFocus) {
        this.$set(submitData, "whatAction", "focus");
      } else {
        this.$set(submitData, "whatAction", "unfocus");
      }
      player
        .toChangePlayerFocusAction(submitData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.getInfo();
          this.isShowPoper = false;
          this.isShowTips = false;
          this.loadFocusHistory();
          this.initdialogForFocus();
        })
        .catch((err) => {
          console.error("err", err);
          this.isShowPoper = false;
          this.isShowTips = false;
          this.initdialogForFocus();
        });
    },

    /* 关闭弹窗 */
    oncancel() {
      this.isShowPoper = false;
      this.isShowTips = false;
      this.initdialogForFocus();
    },
    /* 重置弹窗数据 */
    initdialogForFocus() {
      this.tipsInfo = null;
      this.tipsSelect = null;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.scroll_wrap
  height 100%
  padding 20px 0 10px 20px
  box-sizing border-box
  overflow hidden
  .info_item
    margin 0 30px 30px 10px
    .info_title
      font-size 20px
      padding 10px 0 20px
      display flex
      align-items center
      img
        margin-right 10px
        width 26px
      &.between
        justify-content space-between
        .flex_box
          display flex
          align-items center
        .tutorial
          span
            padding-right 10px
            padding-left 5px
            &:last-child
              padding-right 5px
      .yioks_btn
        padding 6px 20px
      .more
        padding-right 10px
        cursor pointer
    .base_info
      border 1px solid #FFF
      display flex
      .info
        flex 1
      .col
        border-bottom 1px solid #FFF
        border-right 1px solid #FFF
        padding 16px 30px
        display flex
        justify-content space-around
        span
          display inline-block
          width 100%
        &:last-child
          border-bottom 0
      .playerImg
        display flex
        flex-direction column
        justify-content center
        align-items center
        position relative
        .focus-tips
          position absolute
          top 0
          right 0
          width 100px
          height 100px
          overflow hidden
          .tips-content
            width 150px
            height 20px
            line-height 20px
            text-align center
            background-color red
            transform rotate(45deg)
            position absolute
            top 21px
            right -46px
        img
          // width 120px
          // height 120px
          width 80px
          height 80px
          /* height 1.2rem */
          border-radius 50%
          padding 10px
        p
          text-align center
    .score_wrap
      display flex
      flex-wrap wrap
      .score_item
        cursor pointer
        padding-bottom 20px
        width 395px
        // width 830px
        &:nth-child(odd)
          // margin-right 40px
          margin-right 35px
        .header
          height 30px
          background url('~@/assets/images/common/squad_bg.png') no-repeat
          background-size 261px 30px
          line-height 30px
          padding-left 15px
          font-size 18px
        .content
          border 1px solid #FFF
          padding 20px 15px
          display flex
          img
            width 54px
            height 80px
            margin-right 10px
          .score_info
            p
              margin-bottom 10px
              span
                margin-right 20px
                &:last-child
                  margin 0
    .trainTime
      display flex
      border 1px solid white
      .col
        width 50%
        padding 15px
        &:first-child
          border-right 1px solid white
    .trainPlan
      display flex
      justify-content space-between
      flex-wrap wrap
      .planDetail
        border 1px solid white
        width 100%
        .row
          min-height 49px
          display flex
          align-items center
          border-bottom 1px solid white
          &:last-child
            border-bottom none
          .col
            width 50%
            padding 0 10px 0 20px
            height 100%
            line-height 49px
            text-overflow ellipsis
            overflow hidden
            white-space nowrap
            &:first-child
              border-right 1px solid white
        .rowLine
          padding 10px 10px 10px 20px
      .mediaDetail
        background-color rgba(0, 0, 0, 0.7)
        border 1px solid white
        padding 20px
        width 400px
        display flex
        align-items center
        cursor pointer
        .p_item
          margin-bottom 10px
      .img
        width 170px
        height 100px
        position relative
        .coverImg
          width 100%
          height 100%
      .intro
        padding-left 10px
        width calc(100% - 170px)
        height 100px
        display flex
        flex-direction column
        justify-content space-between
    .test-wrap
      border 1px solid #FFF
      .row
        display flex
        .col
          flex 1
          .box-wrap
            flex 1
            display flex
            flex-wrap wrap
            justify-content space-around
            padding 10px 5px 0
            .box
              width 105px
              display flex
              flex-direction column
              // border-right 1px solid #FFF
              // border 1px solid #FFF
              margin-bottom 10px
              p
                flex 1
                display flex
                align-items center
                justify-content center
                min-height 40px
                text-align center
              .content
                border-top 1px dashed #FFF
              .indicatorName
                color #4cd964
          .flex
            display flex
            min-height 40px
            span
              flex 1
              line-height 40px
              padding-left 11px
        .label
          border-right 1px solid #FFF
          padding 15px
          display flex
          align-items center
.btn-wrapper
  display flex
  justify-content center
.w_100
  width 100%
.group_radio
  display flex
  flex-direction column
  align-items center
  label
    margin 0 0 10px
.radio_btn
  display flex
  justify-content center
  padding-top 100px
.col-tips
  position absolute
  top 16px
  right -28px
  width 120px
  height 28px
  display flex
  justify-content center
  align-items center
  transform rotate(42deg)
.over-hidden
  overflow hidden
.nav-right-btn
  font-size 18px
  padding 10px 15px
  display -webkit-box
  display -ms-flexbox
  display flex
  -webkit-box-align center
  -ms-flex-align center
  align-items center
  cursor pointer
  -webkit-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none
  margin-right 10px
  border 1px solid #fff
  &:hover
    background-color #4cd964
    border 1px solid #4cd964
.record-dialog
  color #000
  .title-text
    color #000
    font-size 24px
    border-bottom 1px solid #666
    padding-bottom 10px
.scroll-wrapper
  height 400px
.time-line-wrapper
  padding 0 15px
  .time-item
    display flex
    justify-content center
    align-items center
    margin-bottom 20px
    position relative
    &:first-child
      .line
        border-left none
    .line
      height 59%
      border-left 2px solid #666
      position absolute
      top -34px
      left 25px
    .item-left
      width 50px
      height 50px
      display flex
      justify-content center
      align-items center
      border-radius 50%
      border 1px solid #666
      text-align center
    .item-right
      font-size 16px
      width 90%
      margin-left 20px
      .time-content
        text-indent 2px
      .item-info
        min-height 62px
        border-radius 5px
        border 1px solid #ccc
        padding 12px
.focus-action-tips
  .tips-title-wrapper
    color #000
    font-size 24px
    padding-bottom 10px
    border-bottom 1px solid #666
  .focus-action-content
    font-size 16px
  .tips-text
    margin-bottom 10px
    display flex
    align-items center
  .footer-btns-wrapper
    width 60%
    margin 0 auto
    display flex
    justify-content space-around
    font-size 16px
.yioks-outline:focus
  outline-color #4cd964 !important
  border-color #4cd964 !important
</style>
  <style lang="stylus" scoped>
    .table
      border 1px solid #fff
      .row
        min-height 40px
        display flex
        &:not(:last-child)
          border-bottom 1px solid #fff
        .th, .td
          flex 1
          display flex
          align-items center
          justify-content center
          &:not(:last-child)
            border-right 1px solid #fff
        .work
          flex-basis auto
          width 20%
        .competition
          flex-basis auto
          width 4%
  </style>
<style>
.el-popconfirm {
  font-size: 16px;
}
</style>
